enum UserRoles {
  QS_ADMIN = 'QS_ADMIN',
}

export default UserRoles;
